import React from 'react'
import Result from '../../components/TMS/Result';

const Tms = () => {
    return (
        <Result/>
    )
};

export default Tms;